import React from 'react';
import { SITE_URL } from '@/constants/site';

interface BlogArticleSEOProps {
  headline: string;
  description: string;
  imageUrl: string;
  datePublished: string;
  dateModified: string;
  authorName: string;
  slug: string;
}

export default function BlogArticleSEO({
  headline,
  description,
  imageUrl,
  datePublished,
  dateModified,
  authorName,
  slug,
}: BlogArticleSEOProps) {
  const pageUrl = `${SITE_URL}/blog/${slug}`;

  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline,
    description,
    image: imageUrl,
    author: {
      '@type': 'Organization',
      name: authorName,
    },
    datePublished,
    dateModified,
    publisher: {
      '@type': 'Organization',
      name: 'LitBuy Spreadsheets',
      url: SITE_URL,
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': pageUrl,
    },
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: SITE_URL,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Blog',
        item: SITE_URL,
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: headline,
        item: pageUrl,
      },
    ],
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': pageUrl,
    url: pageUrl,
    name: headline,
    description,
    isPartOf: {
      '@type': 'WebSite',
      name: 'LitBuy Spreadsheets',
      url: SITE_URL,
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
        { '@type': 'ListItem', position: 2, name: headline },
      ],
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(articleSchema),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(breadcrumbSchema),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(webPageSchema),
        }}
      />
    </>
  );
}